import moment from 'jalali-moment';

export const MONTHS = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند'];

export function previousMonth(now = new Date()) {
    const parts = new Intl.DateTimeFormat('en-u-ca-persian-nu-latn', {
        timeZone: 'Asia/Tehran', year: 'numeric', month: 'numeric',
    }).formatToParts(now);
    const year = Number(parts.find(p => p.type === 'year').value);
    const month = Number(parts.find(p => p.type === 'month').value);
    return { currentYear: year, year: month === 1 ? year - 1 : year, month: month === 1 ? 12 : month - 1 };
}

export function daysInMonth(year, month) {
    return moment.jDaysInMonth(Number(year), Number(month) - 1);
}

export function reportRange({ year, month, mode, fromDay, toDay }) {
    const last = daysInMonth(year, month);
    const from = mode === 'custom' ? Math.max(1, Math.min(last, Number(fromDay) || 1)) : 1;
    const to = mode === 'custom' ? Math.max(from, Math.min(last, Number(toDay) || last)) : last;
    const convert = day => moment.from(`${year}/${month}/${day}`, 'fa', 'YYYY/M/D').locale('en').format('YYYY-MM-DD');
    return { from, to, start: convert(from), end: convert(to) };
}

export function journalDetailsUrl(productId, range) {
    return '/app/warehousing/journal?' + new URLSearchParams({
        source: 'monthly-report', productId: String(productId), from: range.start, to: range.end, type: 'OUTFLOW',
    }).toString();
}

export function journalReportFilters(query) {
    const params = new URLSearchParams(query || '');
    if (params.get('source') !== 'monthly-report' || !/^[1-9]\d*$/.test(params.get('productId') || '')) return null;
    const from = params.get('from');
    const to = params.get('to');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(from || '') || !/^\d{4}-\d{2}-\d{2}$/.test(to || '')) return null;
    if (!moment(from, 'YYYY-MM-DD', true).isValid() || !moment(to, 'YYYY-MM-DD', true).isValid() || from > to) return null;
    return { transactionProductId: params.get('productId'), transactionType: 'OUTFLOW',
        transactionCreatedAt: { start: from, end: to }, currentPage: 1 };
}

export function visibleReportRows(rows, hideZero) {
    return hideZero ? rows.filter(row => row.outgoing > 0) : rows;
}

export function stockCapacity(product) {
    const raw = product.stockExpectedMax;
    const valid = (typeof raw === 'number' || (typeof raw === 'string' && /^\d+$/.test(raw)))
        && Number.isSafeInteger(Number(raw)) && Number(raw) >= 0;
    const capacity = valid ? Number(raw) : null;
    return { stockExpectedMax: capacity,
        stockShortage: capacity === null || product.stockLevel == null ? null : Math.max(capacity - Number(product.stockLevel), 0) };
}

export function productUrl(productId, hostname) {
    const base = ['localhost', '127.0.0.1'].includes(hostname) ? 'http://localhost:8183' : 'https://hub.akschap.com';
    return `${base}/node/${encodeURIComponent(productId)}`;
}

export function capacityEditUrl(productId, hostname) {
    return `${productUrl(productId, hostname)}/edit`;
}

function normalizeSearch(value) {
    return String(value ?? '').toLowerCase().replace(/[يى]/g, 'ی').replace(/ك/g, 'ک')
        .replace(/[۰-۹]/g, digit => String('۰۱۲۳۴۵۶۷۸۹'.indexOf(digit)))
        .replace(/[٠-٩]/g, digit => String('٠١٢٣٤٥٦٧٨٩'.indexOf(digit))).trim();
}

export function filterAndSortReport(rows, { hideZero = false, query = '', sortKey = 'sequence', sortDirection = 'asc' } = {}) {
    const search = normalizeSearch(query).replace(/^#/, '');
    const filtered = visibleReportRows(rows, hideZero).filter(row => !search
        || normalizeSearch(row.name).includes(search) || normalizeSearch(row.id).includes(search));
    const key = ['sequence', 'id', 'name', 'outgoing', 'stockLevel', 'stockThreshold', 'stockExpectedMax', 'stockShortage'].includes(sortKey) ? sortKey : 'sequence';
    const direction = sortDirection === 'desc' ? -1 : 1;
    return [...filtered].sort((a, b) => {
        if (key === 'stockExpectedMax' || key === 'stockShortage') {
            if (a[key] == null && b[key] != null) return 1;
            if (a[key] != null && b[key] == null) return -1;
        }
        const comparison = key === 'name' ? String(a.name).localeCompare(String(b.name), 'fa', { numeric: true })
            : Number(a[key] ?? 0) - Number(b[key] ?? 0);
        return comparison * direction || Number(a.sequence ?? 0) - Number(b.sequence ?? 0);
    });
}
